import GpsFixed from '@material-ui/icons/GpsFixed';
import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import styled from 'styled-components';
import { shallowEqual, useSelector } from 'react-redux';
import { DomEvent } from 'leaflet';

import { AppState } from '../../../store/interfaces';
import { registerGeoLocationClickEvent } from '../../../services/reactGa';

const GeoContainer = styled.div`
  position: absolute;
  right: 10px;
  bottom: 120px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  width: 30px;
  height: 30px;
  background: #fff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .leaflet-control {
    margin-top: 5px;
  }
`;

export const GeoButton: React.FC = React.memo(function () {
  const pin = useSelector((app: AppState) => app.map.driverPin);
  const map = useMap();
  const ref = useRef();

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    DomEvent.disableClickPropagation(ref.current);
  }, [ref, pin]);

  if (!pin) {
    return null;
  }

  const handleGeoClick = () => {
    map.flyTo(pin.position);
    registerGeoLocationClickEvent();
  };

  return (
    <GeoContainer
      // @ts-ignore
      ref={ref}
      onClick={handleGeoClick}
      className="leaflet-bar leaflet-control"
    >
      <GpsFixed style={{ color: '#000' }} />
    </GeoContainer>
  );
});
